var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclemask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1441,
    height: 853,
    viewBox: "0 0 1441 853",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1768_19051",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1441,
    height: 853
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.102051,
    width: 1440,
    height: 853,
    fill: "#6935D3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1768_19051)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.58,
    filter: "url(#filter0_f_1768_19051)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 763.092,
    cy: 483.967,
    rx: 763.092,
    ry: 483.967,
    transform: "matrix(-0.893234 -0.449592 0.552151 -0.833744 1506.96 923.585)",
    fill: "#0D226A"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_f_1768_19051)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 940.432,
    cy: 554.68,
    rx: 940.432,
    ry: 554.68,
    transform: "matrix(-0.893234 -0.449592 0.552151 -0.833744 733.649 1623.86)",
    fill: "#6935D3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1768_19051",
    x: -139.76,
    y: -852.652,
    width: 2464.65,
    height: 2059.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_1768_19051"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1768_19051",
    x: -1194.47,
    y: -388.025,
    width: 2788.72,
    height: 2253.23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_1768_19051"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclemask);
export default __webpack_public_path__ + "static/media/circle mask.bb2a23c0e9d1381f05daa4ff33ab52e1.svg";
export { ForwardRef as ReactComponent };